import { Action } from '@ngrx/store';

export enum StudioActionTypes {

  // studio template
  CREATE_STUDIO_TEMPLATE = '[Studio] Create Template',
  CREATE_STUDIO_TEMPLATE_SUCCESS = '[Studio] Create Template Success',

  // studio template
  GET_STUDIO_TEMPLATE = '[Studio] Get Template',
  GET_STUDIO_TEMPLATE_SUCCESS = '[Studio] Get Template Success',

    // studio symbols
  GET_SYMBOLS = '[Studio] Get Symbols',
  GET_SYMBOLS_SUCCESS = '[Studio] Get Symbols Success',

  // studio price points
  GET_PRICE_POINT_TEMPLATES = '[Studio] Get Price Point Templates',
  GET_PRICE_POINT_TEMPLATES_SUCCESS = '[Studio] Get Price Point Template Success',

  // studio offer templates
  // GET_OFFER_TEMPLATES = '[Studio] Get Offer Templates',
  // GET_OFFER_TEMPLATES_SUCCESS = '[Studio] Get Offer Templates Success',

  // studio symbol templates
  GET_SYMBOL_TEMPLATES = '[Studio] Get Symbol Templates',
  GET_SYMBOL_TEMPLATES_SUCCESS = '[Studio] Get Symbol Templates Success',

  // studio template
  EDIT_DOCUMENT_SEGMENT = '[Studio] Edit Document Segment',
  EDIT_DOCUMENT_SEGMENT_SUCCESS = '[Studio] Edit Document Segment Success',

  GET_PAGE_BACKGROUNDS = '[Studio] GET Page Backgrounds',
  GET_PAGE_BACKGROUNDS_SUCCESS = '[Studio] GET Page Backgrounds Success',
  GET_PAGE_BACKGROUNDS_FAILURE = '[Studio] GET Page Backgrounds Failure',

  GET_PAGE_DETAILED_INFO = '[Studio] GET Page Detailed Info',
  GET_PAGE_DETAILED_INFO_SUCCESS = '[Studio] GET Page Detailed Info Success',
  GET_PAGE_DETAILED_INFO_FAILURE = '[Studio] GET Page Detailed Info Failure',

  GET_PAGE_TEMPLATES = '[Studio] GET Page Templates',
  GET_PAGE_TEMPLATES_SUCCESS = '[Studio] GET Page Templates Success',
  GET_PAGE_TEMPLATES_FAILURE = '[Studio] GET Page Templates Failure',

  GET_OFFER_TEMPLATES = '[Studio] GET Offer Templates',
  GET_OFFER_TEMPLATES_SUCCESS = '[Studio] GET Offer Templates Success',
  GET_OFFER_TEMPLATES_FAILURE = '[Studio] GET Offer Templates Failure',

  ASSIGN_PAGE_TEMPLATE = '[Studio] ASSIGN Page Template',
  ASSIGN_PAGE_TEMPLATE_SUCCESS = '[Studio] ASSIGN Page Template Success',
  ASSIGN_PAGE_TEMPLATE_FAILURE = '[Studio] ASSIGN Page Template Failure',

  ASSIGN_OFFER_TEMPLATE = '[Studio] ASSIGN Offer Template',
  ASSIGN_OFFER_TEMPLATE_SUCCESS = '[Studio] ASSIGN Offer Template Success',
  ASSIGN_OFFER_TEMPLATE_FAILURE = '[Studio] ASSIGN Offer Template Failure',

  CHECK_FILE_EXISTS = '[Studio] CHECK File',
  CHECK_FILE_EXISTS_SUCCESS = '[Studio] CHECK Success',
  CHECK_FILE_EXISTS_FAILURE = '[Studio] CHECK Failure',

}

// Studio Templates
export class CreateStudioTemplate implements Action {
  readonly type = StudioActionTypes.CREATE_STUDIO_TEMPLATE;
  constructor(public payload: any) {}
}
export class CreateStudioTemplateSuccess implements Action {
  readonly type = StudioActionTypes.CREATE_STUDIO_TEMPLATE_SUCCESS;
  constructor(public payload: any) {}
}

// Get Studio Template
export class GetStudioTemplate implements Action {
  readonly type = StudioActionTypes.GET_STUDIO_TEMPLATE;
  constructor(public payload: any) {}
}
export class GetStudioTemplateSuccess implements Action {
  readonly type = StudioActionTypes.GET_STUDIO_TEMPLATE_SUCCESS;
  constructor(public payload: any) {}
}


// Studio symbols
export class GetStudioSymbols implements Action {
  readonly type = StudioActionTypes.GET_SYMBOLS;
  constructor(public payload: any) {}
}
export class GetStudioSymbolsSuccess implements Action {
  readonly type = StudioActionTypes.GET_SYMBOLS_SUCCESS;
  constructor(public payload: any) {}
}

// Studio price points
export class GetStudioPricePointTemplates implements Action {
  readonly type = StudioActionTypes.GET_PRICE_POINT_TEMPLATES;
  constructor(public payload: any) {}
}
export class GetStudioPricePointTemplatesSuccess implements Action {
  readonly type = StudioActionTypes.GET_PRICE_POINT_TEMPLATES_SUCCESS;
  constructor(public payload: any) {}
}

// Studio price points
export class GetStudioOfferTemplates implements Action {
  readonly type = StudioActionTypes.GET_OFFER_TEMPLATES;
  constructor(public payload: any) {}
}
export class GetStudioOfferTemplatesSuccess implements Action {
  readonly type = StudioActionTypes.GET_OFFER_TEMPLATES_SUCCESS;
  constructor(public payload: any) {}
}

// Studio price points
export class GetStudioSymbolTemplates implements Action {
  readonly type = StudioActionTypes.GET_SYMBOL_TEMPLATES;
  constructor(public payload: any) {}
}
export class GetStudioSymbolTemplatesSuccess implements Action {
  readonly type = StudioActionTypes.GET_SYMBOL_TEMPLATES_SUCCESS;
  constructor(public payload: any) {}
}


// Studio price points
export class EditDocumentSegment implements Action {
  readonly type = StudioActionTypes.EDIT_DOCUMENT_SEGMENT;
  constructor(public payload: any) {}
}
export class EditDocumentSegmentSuccess implements Action {
  readonly type = StudioActionTypes.EDIT_DOCUMENT_SEGMENT_SUCCESS;
  constructor(public payload: any) {}
}

// Page Backgrounds
export class GetPageBackgrounds implements Action {
  readonly type = StudioActionTypes.GET_PAGE_BACKGROUNDS;
  constructor(public payload: any) {}
}
export class GetPageBackgroundsSuccess implements Action {
  readonly type = StudioActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPageBackgroundsFailure implements Action {
  readonly type = StudioActionTypes.GET_PAGE_BACKGROUNDS_FAILURE;
  constructor(public payload: any) {}
}

// Page Templates
export class GetPageTemplates implements Action {
  readonly type = StudioActionTypes.GET_PAGE_TEMPLATES;
  constructor(public payload: any) {}
}
export class GetPageTemplatesSuccess implements Action {
  readonly type = StudioActionTypes.GET_PAGE_TEMPLATES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPageTemplatesFailure implements Action {
  readonly type = StudioActionTypes.GET_PAGE_TEMPLATES_FAILURE;
  constructor(public payload: any) {}
}

// Page Backgrounds
export class GetOfferTemplates implements Action {
  readonly type = StudioActionTypes.GET_OFFER_TEMPLATES;
  constructor(public payload: any) {}
}
export class GetOfferTemplatesSuccess implements Action {
  readonly type = StudioActionTypes.GET_OFFER_TEMPLATES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetOfferTemplatesFailure implements Action {
  readonly type = StudioActionTypes.GET_OFFER_TEMPLATES_FAILURE;
  constructor(public payload: any) {}
}

// Page Detailed Info
export class GetPageDetailedInfo implements Action {
  readonly type = StudioActionTypes.GET_PAGE_DETAILED_INFO;
  constructor(public payload: any) {}
}
export class GetPageDetailedInfoSuccess implements Action {
  readonly type = StudioActionTypes.GET_PAGE_DETAILED_INFO_SUCCESS;
  constructor(public payload: any) {}
}
export class GetPageDetailedInfoFailure implements Action {
  readonly type = StudioActionTypes.GET_PAGE_DETAILED_INFO_FAILURE;
  constructor(public payload: any) {}
}


// Page Template
export class AssignPageTemplate implements Action {
  readonly type = StudioActionTypes.ASSIGN_PAGE_TEMPLATE;
  constructor(public payload: any) {}
}
export class AssignPageTemplateSuccess implements Action {
  readonly type = StudioActionTypes.ASSIGN_PAGE_TEMPLATE_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignPageTemplateFailure implements Action {
  readonly type = StudioActionTypes.ASSIGN_PAGE_TEMPLATE_FAILURE;
  constructor(public payload: any) {}
}

// Offer Template
export class AssignOfferTemplate implements Action {
  readonly type = StudioActionTypes.ASSIGN_OFFER_TEMPLATE;
  constructor(public payload: any) {}
}
export class AssignOfferTemplateSuccess implements Action {
  readonly type = StudioActionTypes.ASSIGN_OFFER_TEMPLATE_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignOfferTemplateFailure implements Action {
  readonly type = StudioActionTypes.ASSIGN_OFFER_TEMPLATE_FAILURE;
  constructor(public payload: any) {}
}


export class CheckFileExists implements Action {
  readonly type = StudioActionTypes.CHECK_FILE_EXISTS;
  constructor(public payload: any) {}
}
export class CheckFileExistsSuccess implements Action {
  readonly type = StudioActionTypes.CHECK_FILE_EXISTS_SUCCESS;
  constructor(public payload: any) {}
}
export class CheckFileExistsFailure implements Action {
  readonly type = StudioActionTypes.CHECK_FILE_EXISTS_FAILURE;
  constructor(public payload: any) {}
}


export type All =
  | CreateStudioTemplate
  | CreateStudioTemplateSuccess
  | GetStudioTemplate
  | GetStudioTemplateSuccess
  | GetStudioSymbols
  | GetStudioSymbolsSuccess
  | GetStudioPricePointTemplates
  | GetStudioPricePointTemplatesSuccess
  | GetStudioOfferTemplates
  | GetStudioOfferTemplatesSuccess
  | GetStudioSymbolTemplates
  | GetStudioSymbolTemplatesSuccess
  | EditDocumentSegment
  | EditDocumentSegmentSuccess
  | GetPageBackgrounds
  | GetPageBackgroundsSuccess
  | GetPageBackgroundsFailure
  | GetPageTemplates
  | GetPageTemplatesSuccess
  | GetPageTemplatesFailure
  | GetOfferTemplates
  | GetOfferTemplatesSuccess
  | GetOfferTemplatesFailure
  | AssignPageTemplate
  | AssignPageTemplateSuccess
  | AssignPageTemplateFailure
  | AssignOfferTemplate
  | AssignOfferTemplateSuccess
  | AssignOfferTemplateFailure
  | CheckFileExists
  | CheckFileExistsSuccess
  | CheckFileExistsFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/studio.actions.ts